module.exports = __webpack_public_path__ + "icons/original/large/large-d3.87d7030770383023603c79700050ee58.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-d3.png
// module id = PWPq
// module chunks = app